// src/data.js
const cardData = [
    
    {
      id: 1,
      videoSrc: require('../assets/ai.mp4'), 
      title: 'PDFbot',
      description: 'Developed a chatbot using Streamlit and Gemini AI, integrated with LangChain to extract and analyze content from uploaded PDF documents, enabling interactive question-answering.',
      link1: 'https://github.com/sakshams23/PDFbot',
      link2: 'https://pdfbot-genai.streamlit.app/',
    },
    {
      id: 2,
      videoSrc: require('../assets/vc.mp4'), 
      title: 'Crop Recommendation',
      description: 'Developed a Machine learning-based crop recommendation system using RandomForestClassifier, preprocessing data with MinMaxScaler and using soil content and environmental factors for predictions.',
      link1: 'https://github.com/sakshams23/Crop_recommendations',
      link2: 'https://github.com/sakshams23/Crop_recommendations/blob/main/Crop%20Recommendation.ipynb',
    },
{
      id: 3,
      videoSrc: require('../assets/v1.mp4'), 
      title: 'Elderly Ways',
      description: 'This is a Fundraiser web application made using React.js, Tailwind CSS connecting contributors with NGOs and senior citizens in need. Currently adding backend using Express.',
      link1: 'https://github.com/sakshams23/Elderly_ways',
      link2: 'https://elderly-wayss.vercel.app/',
    },
    {
      id: 4,
      videoSrc: require('../assets/v2.mp4'),
      title: 'MyWeather App',
      description: 'Implemented using React.js , MUI , OpenWeatherMap API, chartjs, express.js that provides real-time weather updates & current conditions, hourly forecasts, and 7-day outlook.',
      link1: 'https://github.com/sakshams23/WeatherApp',
      link2: 'https://weather-app-ly7m.vercel.app/',
    },
    {
      id: 5,
      videoSrc: require('../assets/v3.mp4'),
      title: 'Nexgen Digital Solutions',
      description: 'Collaborated with a team to build the official website of the company using MERN stack and Optimized backend services and API endpoints for improved performance and scalability.',
      link1: 'https://github.com/sakshams23/Nexgen-Digital-Solutions',
      link2: 'https://nexgen-digital-solutions.vercel.app/',
    },
    {
      id: 6,
      videoSrc: require('../assets/v5.mp4'),
      title: 'Portfolio Website',
      description: 'A portfolio website built with React and Tailwind CSS offers a modern and dynamic way to showcase your skills and projects. Utilizing React component-based architecture, the site is highly responsive, ensuring smooth navigation and fast load times.',
      link1: 'https://github.com/sakshams23/MyPortfolio',
      link2: 'https://my-portfolio-cj47.vercel.app/',
    },
    {
      id: 7,
      videoSrc: require('../assets/v4.mp4'),
      title: 'Alarm Clock',
      description: 'It is a functional web-based application built using HTML, CSS, and JavaScript. This project allows users to set an alarm for a specific time and notifies them with a sound when the set time is reached.',
      link1: 'https://github.com/sakshams23/Alarm_Clock-using_Js-',
      link2: 'https://alarm-clock-using-js.vercel.app/',
    },
    
    // Add more card data objects as needed
  ];
  
  export default cardData;
  
